// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAjQK-IdPFJL-2eHpmM53maSWu4JmhyzjE",
  authDomain: "eduspace-cc132.firebaseapp.com",
  projectId: "eduspace-cc132",
  storageBucket: "eduspace-cc132.firebasestorage.app",
  messagingSenderId: "828043506537",
  appId: "1:828043506537:web:68736e717a8b61f15d43f8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;